import { render, staticRenderFns } from "./CreateLessonCategoryDialog.vue?vue&type=template&id=45797504"
import script from "./CreateLessonCategoryDialog.vue?vue&type=script&lang=js"
export * from "./CreateLessonCategoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports